<template>
  <div class="fr-mt-2w" :id="discussionUrl(id)">
    <header class="bg-contrast-grey fr-grid-row fr-grid-row--middle justify-between fr-py-2w fr-px-3w no-wrap wrap-md">
      <div class="fr-col-auto text-default-warning fr-text--bold fr-pr-2w" v-if="closed">
        <span>{{ $t("Discussion closed") }}</span>
      </div>
      <h3 class="fr-mx-3v fr-mx-md-0 fr-mb-0">{{ title }}</h3>
      <div class="text-align-right">
        <a
          :id="id + '-copy'"
          :href="discussionUrl(id, true)"
          :data-clipboard-text="discussionExternalUrl(id)"
          class="fr-link fr-link--icon-right unstyled"
        >
          {{$t('Copy permalink')}}
          <span v-html="FillIcon" class="fr-ml-2w"></span>
        </a>
      </div>
    </header>
    <div>
      <transition-group name="list">
        <article
          v-for="comment in _discussion"
          v-if="!_collapsed"
          class="thread-comment fr-py-3w fr-px-3w fr-pr-5w bg-contrast-grey"
          :key="'comment-' + comment.id"
        >
          <div class="fr-grid-row fr-grid-row--gutters">
            <avatar class="fr-col-auto" :user="comment.posted_by"></avatar>
            <div class="fr-col-3">
              <Author :author="comment.posted_by" :badge="false" />
              <div class="fr-text--sm text-mention-grey fr-mb-0">
                {{ $filters.formatDate(comment.posted_on) }}
              </div>
            </div>
            <div class="fr-col">
              <div class="white-space-pre-wrap">
                <p class="fr-mt-3v fr-mb-0">{{ comment.content }}</p>
              </div>
            </div>
          </div>
        </article>
      </transition-group>
      <div class="fr-grid-row" v-if="_collapsed">
        <button
        class="fr-px-3w fr-col fr-link text-mention-grey fr-text--sm fr-mb-0 rounded-0"
        @click.prevent="collapsed = false"
      >
        {{ _discussion.length }} {{ $t("messages") }}
      </button>
      </div>
    </div>
    <footer class="fr-pb-2w">
      <template v-if="!closed && !readOnlyEnabled">
        <!-- <button
          class="fr-btn fr-btn--secondary fr-btn--secondary-grey-500 fr-btn--icon-right fr-fi-arrow-right-s-line"
          v-if="!showForm"
          @click.stop="displayForm"
        >
          {{ $t("Reply") }}
        </button> -->
        <a class="blue-link-arrow"  
          v-if="!showForm"
          @click.stop="displayForm">
            {{ $t("Reply") }}
            <span v-html="ArrowLink" class="fr-ml-1w"></span>
        </a>
        <thread-reply
          :subjectId="id"
          v-else
          :onSubmit="replyToThread"
          @close="showForm = false"
        />
      </template>
      <div v-if="closed" class="text-grey-380">
        {{ $t("The discussion was closed by") }} &#32;
        <strong class="px-xxs"><Author :author="closed_by" /></strong>
        {{ $t("on") }} {{ $filters.formatDate(closed) }}
      </div>
    </footer>
  </div>
</template>

<script>
import ThreadReply from "./thread-reply.vue";
import Avatar from "./avatar.vue";
import Author from "./author.vue";
import config from "../../config";
import FillIcon from "svg/redesign-icons/Fill.svg";
import ArrowLink from "svg/redesign-icons/arrow.svg";

export default {
  components: {
    "thread-reply": ThreadReply,
    Avatar,
    Author,
  },
  props: {
    id: String,
    discussion: Array,
    title: String,
    url: String,
    closed: String,
    closed_by: Object,
  },
  data() {
    return {
      showForm: false,
      updatedDiscussion: null,
      collapsed: true,
      readOnlyEnabled: config.read_only_enabled,
      FillIcon,
      ArrowLink
    };
  },
  computed: {
    _discussion() {
      // Discussion updates are saved locally only
      // This is the logic to get either the original discussion or the updated one
      return this.updatedDiscussion ? this.updatedDiscussion : this.discussion;
    },
    _collapsed() {
      return this.closed && this.collapsed;
    },
  },
  methods: {
    discussionUrl(id, link = false) {
      return (link ? "#" : "") + "discussion-" + id;
    },
    discussionExternalUrl(id) {
      hash = this.discussionUrl(id, true)
      return window.location.origin + window.location.pathname + hash
    },
    replyToThread (values) {
      return this.$api
        .post("/discussions/" + this.id + "/", values)
        .then((resp) => resp.data)
        .then((updatedDiscussion) => {
          this.updatedDiscussion = updatedDiscussion.discussion;
          this.showForm = false;
        });
    },
    displayForm() {
      this.$auth();
      this.showForm = true;
    },
  }
};
</script>
